import { getQuery, updateQuery, deleteQuery } from "./UdasWrapper";
import { addErrorLog } from "../Logger/logger";
import { updateQuery as updateAuth0Query } from "./Auth0Wrapper";

export const inviteUser = async (tenantId, input) => {
  try {
    const data = JSON.stringify({
      query: `mutation InviteUser($tenantId: String!, $input: InviteInput) {
        inviteUser(tenantId: $tenantId, input: $input) {
          isSuccessful
          message
          resultObject
        }
      }`,
      variables: { tenantId, input }
    });
    const response = await updateAuth0Query(data);
    return response?.inviteUser;
  } catch (error) {
    addErrorLog("mutation InviteUser", error, tenantId);
    return null;
  }
};

export const deleteUser = async (tenant_id, auth0_id) => {
  const data = JSON.stringify({
    query: `mutation Mutation($tenantId: String!, $auth0Id: String!) {
            deleteUser(tenant_id: $tenantId, auth0_id: $auth0Id) {
              isSuccessful
              message
              resultObject
            }
          }`,
    variables: {
      tenantId: tenant_id,
      auth0Id: auth0_id
    }
  });
  try {
    const result = await deleteQuery(data);
    return result?.deleteUser;
  } catch (error) {
    addErrorLog("mutation DeleteUser", error, tenant_id);
    return null;
  }
};
export const suspendUser = async (tenant_id, auth0_id, status) => {
  const data = JSON.stringify({
    query: `mutation UpdateUserStatus($auth0Id: String!, $tenantId: String!, $status: String!) {
              updateUserStatus(auth0_id: $auth0Id, tenant_id: $tenantId, status: $status) {
                isSuccessful
                message
                resultObject
              }
            }`,
    variables: {
      tenantId: tenant_id,
      auth0Id: auth0_id,
      status: status
    }
  });
  try {
    return (await updateQuery(data))?.updateUserStatus?.resultObject;
  } catch (error) {
    addErrorLog("mutation UpdateUserStatus", error, tenant_id);
    return null;
  }
};
export const getUserData = async (auth0_id, tenant_id) => {
  const data = JSON.stringify({
    query: `query Query($auth0Id: String!, $tenantId: String!) {
      userbyid(auth0_id: $auth0Id, tenant_id: $tenantId) {
        id
        auth0_id
        tenant_id
        username
        user_type
        role_id
        status
        first_name
        last_name
        organization
        mobile
        phone
        email_address
        created_date_time
        your_location
        language
        image
        user_preferences
        last_active
      }
    }`,
    variables: { auth0Id: auth0_id, tenantId: tenant_id }
  });
  try {
    const result = await getQuery(data, true);

    return result?.userbyid;
  } catch (error) {
    addErrorLog("query Userbyid", error, tenant_id);

    if (/Error\s+502:/.test(error.message)) {
      console.log("Retrying to fetch: getUserData");
      return getUserData(auth0_id, tenant_id);
    }

    return null;
  }
};

export const updateUserPreferences = async (auth0_id, tenant_id, preferences) => {
  const data = JSON.stringify({
    query: `mutation UpdateUserPreferences($tenantId: String!, $auth0Id: String!, $userPreferences: JSON) {
      updateUserPreferences(tenant_id: $tenantId, auth0_id: $auth0Id, user_preferences: $userPreferences) {
        isSuccessful
        message
        resultObject
      }
    }`,
    variables: { auth0Id: auth0_id, tenantId: tenant_id, userPreferences: preferences }
  });
  try {
    const result = await updateQuery(data);

    return result?.updateUserPreferences?.resultObject;
  } catch (error) {
    addErrorLog("mutation UpdateUserPreferences", error, tenant_id);

    return null;
  }
};

export const updateUser = async (tenantId, auth0Id, input) => {
  const data = JSON.stringify({
    query: `mutation UpdateUser($tenantId: String, $auth0Id: String, $input: UserUpdateInput) {
        updateUser(tenant_id: $tenantId, auth0_id: $auth0Id, input: $input) {
          isSuccessful
          message
          resultObject
        }
      }`,
    variables: {
      tenantId,
      auth0Id,
      input: {
        email_address: `${input.email_address}`,
        first_name: `${input.first_name}`,
        mobile: ``,
        last_name: `${input.last_name}`,
        organization: `${input.organization}`,
        phone: `${input.phone}`,
        role_id: `${input.role_id}`,
        user_type: "tenant",
        username: `${input.email_address}`,
        image: `${input.image}`,
        your_location: `${input.your_location}`,
        language: `${input.language}`,
        status: `${input.status}`
      }
    }
  });

  try {
    return (await updateQuery(data))?.updateUser?.resultObject;
  } catch (error) {
    addErrorLog("mutation updateUser", error, tenantId);

    return null;
  }
};
